import { createAsyncThunk } from '@reduxjs/toolkit';

import { LoansService } from 'api';

import { asyncPayloadCreator } from 'utils';

import { InvestInPrimaryMarketItemProps } from 'models/api';

export const investInPrimaryMarketItem = createAsyncThunk(
	'primaryMarket/investInPrimaryMarketItem',
	(data: InvestInPrimaryMarketItemProps, { rejectWithValue }) =>
		asyncPayloadCreator(data, { rejectWithValue }, LoansService.invest),
);
